module.exports = __webpack_public_path__ + "static/media/suwonwomen.357d0832.png";